import {differenceInSeconds} from 'date-fns';

import {useState} from 'react';

import {isNil} from 'ramda';

import {Nullish, parseDate, useInterval} from 'shared/web';

import {CALL_DURATION_TICK_MS} from '../constants/CALL_DURATION_TICK_MS';

/** Seconds since the customer answered, ticking once a second; null before that moment. */
export function useCallElapsedSeconds(connectedAt: string | Nullish) {
  const [now, setNow] = useState(() => new Date());

  useInterval(() => setNow(new Date()), isNil(connectedAt) ? null : CALL_DURATION_TICK_MS);

  if (isNil(connectedAt)) {
    return null;
  }

  return Math.max(0, differenceInSeconds(now, parseDate(connectedAt)));
}
